import { render, staticRenderFns } from "./GoliaListItem.vue?vue&type=template&id=0c9967d0"
import script from "./GoliaListItem.vue?vue&type=script&lang=js"
export * from "./GoliaListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports